import { isDemoMode } from "../config/runtime";
import { setAuthorityState } from "./authority-state";
import type { CurrentActor } from "./session-api";

export {
  assertRequestAuthority,
  authorityFingerprint,
  authorityQueryKey,
  type CatalogueActorAuthority,
  captureRequestAuthority,
  currentQueryAuthority,
  observedCatalogueActor,
  type RequestAuthority,
  requestAuthorityHeader,
} from "./authority-state";

export function setQueryAuthority(actor: CurrentActor | null): void {
  setAuthorityState(actor, isDemoMode);
}
